import {
  Palette,
  Smartphone,
  UserRoundCheck,
  BellRing,
  ScanLine,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

const steps = [
  {
    icon: Palette,
    title: "Créez votre carte",
    description: "Couleurs, logo, texte — votre carte à votre image en quelques minutes.",
  },
  {
    icon: Smartphone,
    title: "Ajout au wallet",
    description: "Le client scanne un QR, entre son nom et email, et la carte arrive dans Apple Wallet ou Google Wallet. Zéro appli.",
  },
  {
    icon: UserRoundCheck,
    title: "Profil client capté",
    description: "Nom, email, téléphone — récupérés dès la création de la carte.",
  },
  {
    icon: ScanLine,
    title: "Tamponnage en un clic",
    description: "Depuis votre tableau de bord, un clic ajoute le tampon — la carte du client se met à jour en temps réel dans son wallet.",
    highlight: true,
  },
  {
    icon: BellRing,
    title: "Il revient",
    description: "Message push instantané ou planifié depuis votre tableau de bord. Relance automatique et géolocalisation incluses.",
  },
];

export function HowItWorks() {
  return (
    <section id="comment-ca-marche" className="bg-cream py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionTag>Comment ça marche</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Simple à mettre en place.
            <br />
            Impossible à oublier.
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            5 étapes. Aucune compétence technique. Vos premiers clients fidélisés dès
            aujourd'hui.
          </p>
        </Reveal>

        <div className="relative mt-16 grid gap-6 md:grid-cols-5">
          <div className="absolute left-0 right-0 top-8 hidden h-px bg-line md:block" />
          {steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 0.08}>
              <div
                className={`relative flex h-full flex-col rounded-2xl border p-5 ${
                  step.highlight
                    ? "border-coral/30 bg-white shadow-soft"
                    : "border-line bg-white shadow-card"
                }`}
              >
                <div
                  className={`mb-4 flex h-11 w-11 items-center justify-center rounded-full ${
                    step.highlight ? "bg-gradient-brand text-white" : "bg-cream-deep text-ink"
                  }`}
                >
                  <step.icon size={20} />
                </div>
                <span className="text-xs font-bold uppercase tracking-wide text-coral">
                  Étape 0{i + 1}
                </span>
                <h3 className="mt-1.5 text-base font-bold text-ink">{step.title}</h3>
                <p className="mt-1.5 text-sm text-ink-soft">{step.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
